module.exports = __webpack_public_path__ + "static/MittagstischLight-64947c2894e1da2ed6c1a4b485cbb0cc.png";